export default __webpack_public_path__ + "static/zendesk-38c1c7a4d7e0ecb21b8efcdd34e89fce.svg";